export enum CustomerEndpoints {
  NEWSLETTER_SUBSCRIBE = '/newsletter/subscribe',
  ORDER_BROCHURE = '/brochure/order'
}
